var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders,
    typography = _ref.typography;
  return {
    borderColor: colors.white,
    hoverBorderColor: colors.electric,
    hoverBorderWidth: borders.widthLarge,
    sidebarClosedButtonPadding: "".concat(spacing.xxSmall, " 0"),
    sidebarHeaderPadding: spacing.small,
    sidebarItemBorderWidth: borders.widthSmall,
    sidebarItemBorderColor: colors.tiara,
    sidebarIsOpenInfoHeaderFontSize: typography.fontSizeXSmall,
    sidebarIsOpenInfoHeaderPadding: spacing.xSmall,
    sidebarIsOpenInfoHeaderMargin: spacing.xSmall,
    sidebarIsOpenInfoHeaderColor: colors.ash
  };
};
export default generateComponentTheme;